import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    postVerificationSizeUpdates,
    setMetadata,
    setOptions,
    overrideComponent,
} from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { generateTrackingId } from './lib/utils/generateTrackingId';
import { StepSuccessComponent } from './components/StepSuccess/StepSuccessComponent';
import { StepFirstResponderPersonalInfoComponent } from './components/StepFirstResponderPersonalInfo/StepFirstResponderPersonalInfoComponent';

const trackingId: string = `FR${generateTrackingId}`;

setMetadata({ trackingIdentifier: trackingId });

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-expect-error
overrideComponent('StepFirstResponderPersonalInfoComponent', StepFirstResponderPersonalInfoComponent);


ReactDOM.render(
    <React.StrictMode>
        <App
            trackingId={trackingId}
        />
    </React.StrictMode>,
    document.getElementById('root'),
);
